<template>
  <el-aside width="156px">
    <div class="aside_logo">
      <img src="@/assets/images/phlogo.png" class="aside_logo-logo" v-if="brand !== '百胜'"/>
      <div v-else>
        <img src="@/assets/images/brand_stripes.png" class="aside_logo-stripes"/>
        <img src="@/assets/images/yum.png" class="aside_logo-logo"/>
      </div>
      <span class="aside_logo-title">时光机</span>
    </div>
    <div v-if="mode === 'home'">
      <div class="aside_section">
        <div class="aside_section-title">
          <img src="@/assets/images/data-icon.png" />
          <span>数据维度</span>
        </div>
      </div>
      <div class="aside_aoishop">
        <el-radio-group :value="AoiShopMode" @input="handleChangeAoiShopMode" class="aside-radio_group flex-row">
          <el-radio class="aside-radio_group-radio" :label="2" :disabled="ShopList.length === 0">驻店</el-radio>
          <el-radio class="aside-radio_group-radio" :label="1" :disabled="AoiList.length === 0">共享</el-radio>
        </el-radio-group>
      </div>
      <div class="aside_aoilist">
        <!-- 共享商圈列表 -->
        <div class="aside_item">
          <div class="aside_date-label">品牌</div>
          <el-select
            :value="activeBrandId"
            class="aside_aoilist-select"
            @input="handleSelectBrand"
            filterable
          >
            <el-option
              v-for="(item) in brandList"
              :key="item.id"
              :label="item.brand_abbr"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="aside_item" v-if="AoiShopMode === 1">
          <div class="aside_date-label">驻店/共享单元</div>
          <el-select
            :loading="loadAoiShopList"
            :value="AoiSelected"
            class="aside_aoilist-select"
            @input="handleSelectAoi"
            filterable
          >
            <el-option
              v-for="(item, index) in AoiList"
              :key="index"
              :label="item.label"
              :value="item.index">
            </el-option>
          </el-select>
        </div>
        <div class="aside_item" v-if="AoiShopMode === 2">
          <div class="aside_date-label">驻店/共享单元</div>
          <el-select
            :loading="loadAoiShopList"
            :value="ShopSelected"
            class="aside_aoilist-select"
            @input="handleSelectShop"
            filterable
          >
            <el-option
              v-for="(item, index) in ShopList"
              :key="index"
              :label="item.label"
              :value="item.index">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="aside_date">
        <div class="aside_date-label">日期</div>
        <el-date-picker
          :clearable="false"
          :value="kfcDate"
          :picker-options="datePickerOptions"
          @input="handleChangeDate"
          class="aside_date-select"
          type="date"
          size="large"
          placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="aside_section">
        <div class="aside_section-title">
          <img src="@/assets/images/icon_navi_data.png" />
          <span>展示模式</span>
        </div>
      </div>
      <div class="aside_viewmode">
        <el-radio-group :value="ViewMode" @input="handleChangeViewMode" class="aside-radio_group flex-col">
          <el-radio class="aside-radio_group-radio" :label="2" >列表模式</el-radio>
          <el-radio class="aside-radio_group-radio" :label="1" >地图模式</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div v-else-if="mode === 'rider'">
      <div class="aside_back-btn" @click="backHome">
        <i class="el-icon-arrow-left"></i> 返回
      </div>
      <div class="aside_section">
        <span class="aside_section-title">
          骑手信息
        </span>
      </div>
      <div class="aside_section">
        <span class="aside_section-subtitle">骑手姓名</span>
        <span class="aside_section-content">{{riderName}}</span>
      </div>
      <div class="aside_date" style="margin-top: 30px;">
        <div class="aside_date-label">日期</div>
        <el-date-picker
          :clearable="false"
          :value="kfcDate"
          @input="handleChangeDate"
          class="aside_date-select"
          type="date"
          size="large"
          placeholder="选择日期">
        </el-date-picker>
      </div>
    </div>
    <div v-else-if="mode === 'order'" style="max-height: 65vh; overflow: auto;">
      <div class="aside_back-btn" @click="backHome">
        <i class="el-icon-arrow-left"></i> 返回
      </div>
      <div class="aside_section">
        <span class="aside_section-title">
          订单信息
        </span>
      </div>
      <div class="aside_section">
        <span class="aside_section-subtitle">餐厅名称</span>
        <span class="aside_section-content">{{orderDetail.shop_name}}
          <span class="circle circle--blue" v-if="orderDetail.dispatch_type != 1">驻</span>
        </span>
      </div>
      <div class="aside_section" style="cursor: pointer;" @click="handleShowOrderDetail">
        <span class="aside_section-subtitle">订单ID <i class="el-icon-arrow-right"/></span>
        <span class="aside_section-content"><a>{{orderDetail.order_id}}</a></span>
      </div>
      <div class="aside_section">
        <span class="aside_section-subtitle">用户地址</span>
        <span class="aside_section-content">{{orderDetail.user_address}}</span>
      </div>
      <div class="aside_section">
        <span class="aside_section-subtitle">配送距离</span>
        <span class="aside_section-content">{{orderDetail.total_distance}}KM</span>
      </div>
      <div class="aside_section">
        <span class="aside_section-subtitle">配送金额</span>
        <span class="aside_section-content">￥{{orderDetail.total_price}}</span>
      </div>
    </div>
  </el-aside>
</template>

<script>
import dayjs from 'dayjs';
import { brand } from 'common/utils';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TravellerAside',
  data() {
    return {
      brand,
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  props: {
    mode: {
      type: String, // 首页：'home' , 订单模式：'order' , 骑手模式：'rider'
      default: 'home',
    },
    orderDetail: {
      type: Object,
    },
    riderName: {
      type: String,
      default: '刘强东',
    },
  },
  computed: {
    ...mapState({
      timestamp: state => state.timestamp,
      AoiShopMode: ({ aside }) => aside.AoiShopMode,
      AoiShopModeList: ({ aside }) => aside.AoiShopModeList,
      ViewMode: ({ aside }) => aside.ViewMode,
      loadAoiShopList: ({ aside }) => aside.loadAoiShopList,
      AoiList: ({ aside }) => aside.AoiList,
      ShopList: ({ aside }) => aside.ShopList,
      AoiSelected: ({ aside }) => aside.AoiSelected,
      ShopSelected: ({ aside }) => aside.ShopSelected,
      brandList: ({ aside }) => aside.brandList,
      activeBrandId: ({ aside }) => aside.activeBrandId,
    }),
    kfcDate() {
      // return this.timestamp * 1000;
      // 如果时间在0点到4:59:59之间 前推5小时 使日期保留在KFC日期当日
      const realTime = dayjs(this.timestamp * 1000);
      if (realTime.hour() < 5) {
        return realTime.subtract(5, 'hour').toDate();
      }
      return realTime.toDate();
    },
  },
  mounted() {
    this.mode === 'home' && this.requestAoiShopList();
    this.requestBrandList();
  },
  methods: {
    ...mapActions([
      'requestAoiShopList',
      'requestBrandList',
      'handleChangeAoiShopMode',
      'handleChangeViewMode',
      'handleSelectShop',
      'handleSelectAoi',
      'handleSelectBrand',
      'handleChangeDate',
    ]),
    handleShowOrderDetail() {
      this.$emit('show-order-detail', true);
    },
    backHome() {
      window.location.href = 'homepage.html';
    },
  },
};
</script>

<style lang="less" scoped>
.el-aside {
  opacity: 0.8;
  box-sizing: border-box;
  background: #ffffff;
  position: absolute;
  min-height: 100%;
  z-index: 1000;
  top: 0;
  left: 0;
  transition: 0.3s;
  height: 100vh;
  overflow: auto;
  padding-bottom: 90px;

  &:hover {
    opacity: 1;
  }
}


.aside_logo {
  display: block;
  text-align: center;
  padding: 0 18px;
  margin-bottom: 20px;

  &-stripes {
    width: 100%;
  }

  &-logo {
    margin-top: 25px;
    margin-bottom: 10px;
    width: 100%;
  }

  &-title {
    font-size: 24px;
    color: #333333;
    letter-spacing: 10px;
  }
}

/* 返回按钮 */
.aside_back-btn {
  padding-left: 20px;
  color: #666666;
  font-size: 16px;
  margin-bottom: 12px;
  cursor: pointer;
}

.aside_section {
  padding: 0 20px;
  margin-bottom: 20px;

  img {
    margin-right: 10px;
  }
  &-title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    display: flex;
    align-items: center;
  }

  &-subtitle {
    display:block;
    color: #666666;
    font-size: 14px;
    opacity: 0.6;
    margin-bottom: 8px;
  }

  &-content {
    display: block;
    width: 100%;
    font-size: 12px;
    color: #666666;
    word-break: break-all;
  }
}
/* 数据维度 单选框group */
.aside_aoishop {
  padding: 0 18px 0 20px;
  margin-bottom: 8px;
}

/* 展示模式 单选框group */
.aside_viewmode {
  padding: 0 20px;
}

/* 修改elementUI 单选框样式 */
.aside-radio_group {
  &.flex-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  &.flex-col {
    display: flex;
    flex-direction: column;
  }

  /deep/&-radio {
    margin: 0;
    margin-bottom: 10px;
    font-weight: 400;

    .el-radio__label {
      padding-left: 9px;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #666666;
    }

    .el-radio__input.is-checked .el-radio__inner::after {
      transform: rotate(45deg) scaleY(1);
    }

    .el-radio__inner {
      width: 18px;
      height: 18px;
      border-color: rgba(153, 153, 153, 0.5);
      background: #ffffff;
      display: inline-block;
      position: relative;
      box-sizing: border-box;
      z-index: 1;
      transition: border-color 0.25s;

      &:after {
        box-sizing: content-box;
        content: "";
        border: 1px solid #666666;
        border-radius: 0;
        border-left: 0;
        border-top: 0;
        height: 7px;
        left: 6px;
        position: absolute;
        top: 3px;
        transform: rotate(45deg) scaleY(0);
        width: 3px;
        transition: transform 0.15s ease-in 0.05s;
        transform-origin: center;
      }
    }
  }
}
.aside_item {
  margin-bottom: 20px;
}
.aside_date {
  margin-bottom: 40px;
}

.aside_aoilist,
.aside_date {
  padding-left: 20px;
  padding-right: 18px;

  &-label {
    margin-bottom: 10px;
    font-size: 14px;
    color: #666666;
  }

  /* 修改elementUI 下拉框样式 */
  /deep/&-select {
    width: 120px;
    height: 35px;

    .el-input__inner {
      padding: 0 15px;
      line-height: 35px;
    }

    .el-select__caret {
      color: #666666;
    }

    /* 隐藏datepick 日期icon */
    .el-input__prefix {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TravellerAside.vue